import { useIntl } from 'react-intl';

import styles from './ProgressIndicator.module.scss';

interface Props {
    progress: number;
}
const COLOR_LINE = 'rgb(75, 225, 160)';
const COLOR_RAIL = 'rgb(238, 237, 242)';
const MIN = 0;
const MAX = 100;

const AccessibleIndicator = ({ progress }: Props) => {
    return <progress className={styles.hiddenAccessible} value={progress} max={MAX} />;
};

export const ProgressIndicator = ({ progress }: Props) => {
    const { formatMessage } = useIntl();
    return (
        <div>
            <div
                className={styles.rail}
                role="progressbar"
                aria-valuenow={progress}
                aria-valuemin={MIN}
                aria-valuemax={MAX}
                aria-label={formatMessage({ id: 'Progress bar' })}
                style={{
                    backgroundColor: COLOR_RAIL,
                }}
            >
                <div
                    className={styles.line}
                    style={{
                        backgroundColor: COLOR_LINE,
                        width: `${progress}%`,
                    }}
                ></div>
            </div>
            <AccessibleIndicator progress={progress} />
        </div>
    );
};
